import React from "react";
import CardLayout from '../common/CardLayout';
import { useIntl } from "react-intl";

interface CardDrugOPDStatOrderProps {
  onClose?: () => void;
  toggleable?: boolean;
}

const DEFAULT_PROPS = {
  onClose: () => {},
  toggleable: true,
}

const CardDrugOPDStatOrder = React.forwardRef<any,CardDrugOPDStatOrderProps>((propsParam, ref) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  return (
    <CardLayout 
      titleText="สั่งยา STAT" 
      onClose={props.onClose}
      toggleable={props.toggleable}
    >
      asdasdasd
    </CardLayout>
  )
})

CardDrugOPDStatOrder.displayName = "CardDrugOPDStatOrder"



export default React.memo(CardDrugOPDStatOrder);